export interface CCTOperacion {
    idCliente: string;
    cuenta: string;
    codigoTipoTransaccion: number;
    numeroTransaccion: string;
    fecha: any;
    valor: any;
    estatusMovimiento: string;
    fechaRegistro: any;
    usuarioRegistro: string;
    fechaAnulado: any;
    usuarioAnulo: string;
    numeroDeDocumentoContable: any;
    pagado: boolean
}

export class CCTOperacion implements CCTOperacion {
    constructor(init?: CCTOperacionesFormValues) {
        Object.assign(this, init);
    }
}

export class CCTOperacionesFormValues {
    idCliente: string = "";
    cuenta: string = "";
    codigoTipoTransaccion: number = 0;
    numeroTransaccion: string = ""
    fecha: Date | null = null;
    valor: string = "";
    estatusMovimiento: string = "";
    fechaRegistro: Date | null = null;
    usuarioRegistro: string = "";
    fechaAnulado: Date | null = null;
    usuarioAnulo: string = "";
    numeroDeDocumentoContable: string = "";
    pagado: boolean=false

    constructor(CCTOperacion?: CCTOperacionesFormValues) {
        if (CCTOperacion) {
            this.idCliente = CCTOperacion.idCliente;
            this.cuenta = CCTOperacion.cuenta;
            this.codigoTipoTransaccion = CCTOperacion.codigoTipoTransaccion;
            this.numeroTransaccion = CCTOperacion.numeroTransaccion;
            this.fecha = CCTOperacion.fecha;
            this.valor = CCTOperacion.valor;
            this.estatusMovimiento = CCTOperacion.estatusMovimiento;
            this.fechaRegistro = CCTOperacion.fechaRegistro;
            this.usuarioRegistro = CCTOperacion.usuarioRegistro;
            this.fechaAnulado = CCTOperacion.fechaAnulado;
            this.usuarioAnulo = CCTOperacion.usuarioAnulo;
            this.numeroDeDocumentoContable = CCTOperacion.numeroDeDocumentoContable
            this.pagado = CCTOperacion.pagado
        }

    }
}